import { useLocation, Outlet } from 'react-router-dom'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import Header from './Header'
import BottomMenu from '../BottomMenu/BottomMenu'
import './Layout.css'

const ROUTES_WITHOUT_HEADER = ['/profile', '/courses', '/favorites']

const Layout = () => {
  const location = useLocation()
  const { webApp } = useTelegramWebApp()

  const showHeader = !ROUTES_WITHOUT_HEADER.includes(location.pathname)

  return (
    <div className="layout">
      {showHeader && <Header />}
      <main className="main-content">
        <Outlet />
      </main>
      <BottomMenu />
    </div>
  )
}

export default Layout
